import moment from "moment";
export default function(value) {
	return moment(value)
		.locale("en-GB")
		.format("L");
}
